'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { useSticky, useUi } from '@weareconceptstudio/core';
import { AccountTemplate } from '@weareconceptstudio/account';
import { useGetLangPath } from '@/helpers';

const Template = ({ children }) => {
	const pathname = usePathname();
	const getLangPath = useGetLangPath();
	const { winWidth } = useUi();

	useSticky({
		enabled: true,
		breakpoint: 1024,
		loading: false,
		dependencies: [winWidth],
		elementClassName: '.sidebar',
		pinClassName: '.sidebar-inner-wrap',
		containerClassName: '.account-container',
		headerName: 'header',
	});

	const menuOptions = useMemo(() => {
		return [
			{
				url: '/account/',
				name: 'account.sidebar.accountSettings',
				className: pathname === getLangPath('account') ? 'active' : '',
			},
			{
				url: '/account/order-history/',
				name: 'account.sidebar.orderHistory',
				className: pathname === getLangPath('orderHistory') ? 'active' : '',
			},
			{
				url: '/account/my-cards/',
				name: 'account.sidebar.myCards',
				className: pathname === getLangPath('myCards') ? 'active' : '',
			},
			{
				url: '/account/addresses/',
				name: 'account.sidebar.addresses',
				className: pathname === getLangPath('accountAddresses') ? 'active' : '',
			},
			{
				url: '/account/balance/',
				name: 'account.sidebar.balance',
				className: pathname === getLangPath('accountBalance') ? 'active' : '',
			},
		];
	}, [pathname, getLangPath]);

	return (
		<AccountTemplate
			menuOptions={menuOptions}
			pathname={pathname}>
			{children}
		</AccountTemplate>
	);
};

export default Template;
